import React, { useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { GET_NEW_TAX_REVENUES_GARBAGE } from '../../../../constant';
import { getNewTaxRevenuesGarbageList } from '../../../../action';

const selectList = ({ api }) => {
  return _.get(api, `${GET_NEW_TAX_REVENUES_GARBAGE}.list`) || [];
};

const formatOptions = data => {
  return data.map(item => {
    return {
      label: _.get(item, 'attributes.code'),
      value: _.get(item, 'attributes.code'),
      fullInfo: item,
    };
  });
};

const TaxRevenues = ({
  name,
  onChange,
  value,
  readOnly,
  ordinanceRevisionId,
}) => {
  const dispatch = useDispatch();
  const list = useSelector(selectList);
  const options = [...formatOptions(list)];

  const findValue =
    options.find(item => _.get(item, 'fullInfo.attributes.code') === value) ||
    '';

  useEffect(() => {
    dispatch(
      getNewTaxRevenuesGarbageList({
        tax_revenue_type_id: 4,
        q: value,
        ordinance_revision_id: ordinanceRevisionId,
      })
    );
  }, [value, ordinanceRevisionId]);

  const handleChange = data => {
    onChange({
      target: {
        name,
        value: data.value,
        label: data.label,
      },
    });
  };

  const loadOptions = (inputValue, callback) => {
    dispatch(
      getNewTaxRevenuesGarbageList(
        {
          tax_revenue_type_id: 4,
          q: inputValue,
          ordinance_revision_id: ordinanceRevisionId,
        },
        response => {
          callback(formatOptions(_.get(response, 'data')));
        }
      )
    );
  };

  const loadOptionsDebounce = _.debounce(loadOptions, 500);

  return readOnly === true ? (
    <span className="full-input text-uppercase">
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <AsyncSelect
      placeholder="- Select -"
      value={findValue}
      onChange={handleChange}
      defaultOptions={formatOptions(list)}
      loadOptions={loadOptionsDebounce}
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};

TaxRevenues.defaultProps = {
  name: undefined,
  readOnly: undefined,
};

TaxRevenues.propTypes = {
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

export default TaxRevenues;
